import { Button, Modal, Paper, withStyles, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import translate from '../../locales';
import ErrorMessage from '../ErrorMessage';
import { dateFormat, jsonDateFormat } from '../../_helpers/dateConvert';
import moment from 'moment';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const __t = translate;

const styles = () => ({
    button: {
        marginTop: '30px'
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    paper: {
        width: '500px',
        textAlign: "center",
        padding: '20px 10px',
        outline: "none"
    }
})

const ErrorPeriodShortStayOverlap = props => {
    const { classes } = props;

    console.log(props, 'props in ErrorPeriodShortStayOverlap');

    return (
        <Modal className={classes.modal} open={props.overlapPeriodSs != null}>
            <Paper className={classes.paper}>
                <ErrorMessage
                    error={__t('error_period_aux_overlap_short_stays')}
                />
                <div style={{ overflowY: 'auto', maxHeight: '400px', marginTop: '20px' }}>
                    {props.overlapPeriodSs != null ?
                        props.overlapPeriodSs.map((op, i) =>
                            <ExpansionPanel key={`err-overlap-${i}`} style={{ marginTop: '10px' }}>
                                <ExpansionPanelSummary style={{ backgroundColor: '#d9d9d9' }}>
                                    <ExpandMoreIcon style={{ marginRight: 8 }} />
                                    <span><strong>{op.rateName}</strong>: {moment(op.period.fromDate, jsonDateFormat).format(dateFormat)} - {moment(op.period.toDate, jsonDateFormat).format(dateFormat)}</span>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails style={{ borderTop: '1px solid #ddd' }}>
                                    <div style={{ textAlign: 'left', width: '100%' }}>
                                        <div style={{ textDecoration: 'underline' }}>{__t('positions')}</div>
                                        <div style={{ width: '100%', overflowX: 'auto', whiteSpace: 'nowrap', border: '1px solid #ddd', paddingTop: '10px', paddingBottom: '10px' }}>{op.positions.join(', ')}</div>

                                        <div style={{ marginTop: '10px', textDecoration: 'underline' }}>{__t(op.type === 'GROUPS' ? 'groups' : 'emission_profiles')}</div>
                                        <div style={{ width: '100%', overflowX: 'auto', whiteSpace: 'nowrap', border: '1px solid #ddd', paddingTop: '10px', paddingBottom: '10px' }}>{op.auxValues.join(', ')}</div>
                                    </div>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        )
                        :
                        null
                    }
                </div>

                <Button className={classes.button} onClick={props.onOkClick} variant="outlined" color="primary">{__t('ok')}</Button>
            </Paper>
        </Modal >
    )
}

ErrorPeriodShortStayOverlap.propTypes = {
    overlapPeriodSs: PropTypes.array,
    onOkClick: PropTypes.func
}


export default withStyles(styles)(ErrorPeriodShortStayOverlap);

